import { render, staticRenderFns } from "./standort-einstellungen.vue?vue&type=template&id=6b10a5b7&scoped=true&"
import script from "./standort-einstellungen.vue?vue&type=script&lang=js&"
export * from "./standort-einstellungen.vue?vue&type=script&lang=js&"
import style0 from "./standort-einstellungen.vue?vue&type=style&index=0&id=6b10a5b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10a5b7",
  null
  
)

export default component.exports